import React, { useState } from 'react'
import SendIcon from '@mui/icons-material/Send'
import { Button } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { terminatedUsersRowsType } from 'types/api/faber/terminated.type'

import { TerminatedIndivEmailDialog } from '../dialogs'

export interface IMenuProps {
  customerRow: terminatedUsersRowsType
  refetchAllusers: () => void
}
export default function TerminatedPageActionMenu({
  customerRow,
  refetchAllusers
}: IMenuProps) {
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)

  const handleOpenDialog = () => {
    setConfirmDialogOpen(true)
  }
  return (
    <>
      <Button
        onClick={() => {
          handleOpenDialog()
        }}
        sx={{
          backgroundColor: circlesOrbitColorPalette.primary.disabled,
          borderColor: circlesOrbitColorPalette.text.light,
          borderWidth: 0.5,
          ':hover': {
            backgroundColor: circlesOrbitColorPalette.primary.dark
          }
        }}
      >
        <SendIcon sx={{ color: circlesOrbitColorPalette.neutrals[0] }} />
      </Button>
      <TerminatedIndivEmailDialog
        setConfirmDialogOpen={setConfirmDialogOpen}
        confirmDialogOpen={confirmDialogOpen}
        refetchAllUsers={refetchAllusers}
        customerRow={customerRow}
      />
    </>
  )
}
